import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { TextField, makeStyles } from "@material-ui/core";
const useStyles = makeStyles({
  rootPassword: {
    paddingTop: "10%",
  },
});
function Password({ password, onChnagePassword, errorValue, errorText }) {
  const classes = useStyles();
  return (
    <div className={classes.rootPassword}>
      <TextField
        required
        fullWidth
        error={errorValue}
        helperText={errorText}
        label="비밀번호"
        type="password"
        variant="filled"
        defaultValue={password}
        inputProps={{
          maxLength: 20,
        }}
      ></TextField>
    </div>
  );
}
Password.propTypes = {
  password: PropTypes.string,
  onChangePassword: PropTypes.func,
  errorText: PropTypes.string,
  errorValue: PropTypes.bool,
};
export default Password;
